/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TransportState,
    TransportStateFromJSON,
    TransportStateFromJSONTyped,
    TransportStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost
 */
export interface BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost {
    /**
     * 
     * @type {number}
     * @memberof BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost
     */
    monitoredObject?: number;
    /**
     * 
     * @type {Date}
     * @memberof BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost
     */
    start?: Date;
    /**
     * 
     * @type {TransportState}
     * @memberof BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost
     */
    state?: TransportState;
}

export function BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPostFromJSON(json: any): BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost {
    return BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPostFromJSONTyped(json, false);
}

export function BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObject': !exists(json, 'monitored_object') ? undefined : json['monitored_object'],
        'start': !exists(json, 'start') ? undefined : (new Date(json['start'])),
        'state': !exists(json, 'state') ? undefined : TransportStateFromJSON(json['state']),
    };
}

export function BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPostToJSON(value?: BodyAttachMonitoredObjectV1TransportsTransportIdAttachMonitoredObjectPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object': value.monitoredObject,
        'start': value.start === undefined ? undefined : (value.start.toISOString()),
        'state': TransportStateToJSON(value.state),
    };
}


